module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="' +
((__t = (id)) == null ? '' : __t) +
'" class="' +
((__t = (dialogClass)) == null ? '' : __t) +
' modal" role="dialog" style="display:block;position:fixed;pointer-events: none;">\n    <!--<div class="modal-dialog" role="document" style="position:absolute;left:50%;top:50%;-webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);pointer-events: none;">-->\n    <div class="modal-dialog" role="document">\n        <!-- Modal content-->\n        <div class="modal-content" style="pointer-events:auto;">\n            <form id="' +
((__t = (id)) == null ? '' : __t) +
'_formDialog" class="' +
((__t = (formClass)) == null ? '' : __t) +
'">\n                <div class="modal-header">\n                    <h4 class="DescartesModalTitle modal-title">' +
((__t = (title)) == null ? '' : __t) +
'</h4>\n                    <button id="' +
((__t = (id)) == null ? '' : __t) +
'_close" type="button" class="close" data-dismiss="modal" aria-label="Close">\n                        <span aria-hidden="true">&times;</span>\n                    </button>\n                </div>\n                <div class="modal-body">\n                    ' +
((__t = (content)) == null ? '' : __t) +
'\n                </div>\n                <div class="modal-footer">\n                	';
 if(otherBtnLabel) { ;
__p += '\n                    	<button id="' +
((__t = (id)) == null ? '' : __t) +
'_otherAction" type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" data-dismiss="modal">' +
((__t = (otherBtnLabel)) == null ? '' : __t) +
'</button>\n                    ';
 };
__p += '\n                    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (sendLabel)) == null ? '' : __t) +
'</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/FormDialog.ejs
// module id = 312
// module chunks = 0